<template>
  <div class="home">
    <div class="main">
      <transition name="el-fade-in-linear">
        <div class="box" v-show="ready" :style="{background:'url('+data.img+') no-repeat center top'}">
          <div class="age">{{data.w1}}</div>
          <div class="en">{{data.w2}}</div>
          <div class="en">{{data.w3}}</div>
          <div class="cn">{{data.w4}}</div>
        </div>
      </transition>
      <div class="not_ready" v-if="!ready">loading…</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {getHomeData} from "../request/service";
export default {
  name: 'Home',
  data(){
    return{
      ready:false,
      data:{
        w1:'175 - 1920 - 1111',
        w2:'HUANG DA',
        w3:'XIAN',
        w4:'李 大 仙',
          img:''
      }
    }
  },
  created() {
      const that=this
      getHomeData().then(res=>{
          that.data=res.data
          that.ready=true
      })
  }
}
</script>

<style scoped>
  .home{
    width: 96%;
    margin: 30px 2%;
    background: #242424;
  }
  .home .main{
    width: 1200px;
    margin: auto;
    padding: 150px 0;
    text-align: center;
    color: #ffffff;
    min-height: 370px;
  }
  .box{
    padding: 100px 0 0 0;
  }
  .age{
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-family: 'software';
  }
  .en{
    font-family: 'Continuum_Light';
    font-size: 5rem;
  }
  .cn{
    margin-top: 1rem;
  }
</style>
